export default "__VITE_ASSET__CujUMXIz__"